import React from 'react';
import { Button } from 'semantic-ui-react';

const TableFilterButtons = (props) => {
  const {
    activeFilter,
    buttons,
    onFilterButtonClick,
    loading,
  } = props;

  const mapButtons = buttons.map((button, i) => {
    return (
      <Button
        key={i}
        content={button.text}
        basic={activeFilter === button.value ? false : true}
        color={button.color}
        disabled={loading ? true : false}
        onClick={e => onFilterButtonClick(e, button.value)}
      />
    );
  })

  return (
    <div>
      {mapButtons}
    </div>
  );
};

export default TableFilterButtons;
